import { defineComponent as _defineComponent } from 'vue'
import moment from 'moment'
import User from '../../models/user'
import { useStore } from 'vuex-composition-helpers'
import { computed } from 'vue'
import { getInstance } from '@/auth/auth.js'
import { User as UserAuth0 } from '@auth0/auth0-spa-js'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatedInfo',
  props: {
    creatorSid: null,
    createdTime: { default: undefined },
    textType: { default: 'paragraph' }
  },
  setup(__props: any) {

const props = __props as { creatorSid: string, createdTime: object | string, textType: string }


const store = useStore()
const auth: { user: UserAuth0 } = getInstance()
const getUserBySid = computed<(id: string) => User>(
  () => store.getters['users/getBySid']
)
const creatorName = computed(() => {
  const creator = getUserBySid.value(props.creatorSid)
  if (!creator && props.creatorSid === auth.user.sub) {
    // In the case of Global Admin, the 'creator' object is null, so we fallback to Auth0's name
    return auth.user.nickname
  }
  return creator ? creator.name : 'Unknown User'
})
const formattedCreatedTime = computed(() =>
  props.createdTime
    ? moment.utc(props.createdTime).local().format('MMM DD, HH:mm')
    : ''
)

return { __sfc: true,props, store, auth, getUserBySid, creatorName, formattedCreatedTime }
}

})